<div class="row thankyou-media columns">
	<i class="twingle-check_checked" *ngIf="!videoEmbedUrl && !thankyouImage"></i>
	<iframe *ngIf="videoEmbedUrl" width="768" height="432" [src]="videoEmbedUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen (load)="scrollUp()"></iframe>
	<img *ngIf="thankyouImage" [src]="thankyouImage" alt="" (load)="scrollUp()">
</div>
